import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Mail, Phone, MapPin, Globe, MessageCircle } from 'lucide-react';

export default function ContactUs() {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6" data-testid="contact-us-page">
      <h1 className="text-2xl font-semibold tracking-tight">Contact Us</h1>

      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Get in Touch</CardTitle>
            <CardDescription>We'd love to hear from you</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center gap-3">
              <Mail className="h-5 w-5 text-primary" />
              <div>
                <p className="font-semibold">Email</p>
                <a href="mailto:support@lockene.us" className="text-sm text-muted-foreground hover:text-primary">
                  support@lockene.us
                </a>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Phone className="h-5 w-5 text-primary" />
              <div>
                <p className="font-semibold">Phone</p>
                <a href="tel:+1234567890" className="text-sm text-muted-foreground hover:text-primary">
                  +1 (234) 567-890
                </a>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <MapPin className="h-5 w-5 text-primary" />
              <div>
                <p className="font-semibold">Address</p>
                <p className="text-sm text-muted-foreground">
                  123 Business Street<br />
                  Suite 100<br />
                  San Francisco, CA 94103<br />
                  United States
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Globe className="h-5 w-5 text-primary" />
              <div>
                <p className="font-semibold">Website</p>
                <a href="https://lockene.us" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary">
                  www.lockene.us
                </a>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Support</CardTitle>
            <CardDescription>Get help when you need it</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center gap-3">
              <MessageCircle className="h-5 w-5 text-primary" />
              <div className="flex-1">
                <p className="font-semibold">Create Support Ticket</p>
                <p className="text-sm text-muted-foreground mb-2">
                  Need help? Our support team is here for you.
                </p>
                <Button onClick={() => navigate('/settings/supports')} variant="outline" size="sm">
                  Create Ticket
                </Button>
              </div>
            </div>

            <div className="pt-4 border-t">
              <h3 className="font-semibold mb-2">Support Hours</h3>
              <div className="text-sm text-muted-foreground space-y-1">
                <p>Monday - Friday: 9:00 AM - 6:00 PM PST</p>
                <p>Saturday: 10:00 AM - 4:00 PM PST</p>
                <p>Sunday: Closed</p>
              </div>
            </div>

            <div className="pt-4 border-t">
              <h3 className="font-semibold mb-2">Average Response Time</h3>
              <div className="text-sm text-muted-foreground space-y-1">
                <p>Email Support: Within 24 hours</p>
                <p>Support Tickets: Within 12 hours</p>
                <p>Urgent Issues: Within 2 hours</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Office Locations</CardTitle>
          <CardDescription>Find us around the world</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-6 md:grid-cols-3">
            <div>
              <h3 className="font-semibold mb-2">Headquarters - USA</h3>
              <p className="text-sm text-muted-foreground">
                123 Business Street<br />
                San Francisco, CA 94103<br />
                United States
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Europe Office</h3>
              <p className="text-sm text-muted-foreground">
                456 Tech Avenue<br />
                London, EC1A 1BB<br />
                United Kingdom
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Asia Pacific</h3>
              <p className="text-sm text-muted-foreground">
                789 Innovation Road<br />
                Singapore 018956<br />
                Singapore
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
